import { BundleItemFunctionalityType } from "./Bundle.dto";
import { INVENTORY_UNLIMITED_QUANTITY } from "./Inventory.dto";
import { MySubscription, MySubscriptionInventory, MySubscriptionLicense } from "./Subscription.dto";
import { hasOwnProperty } from "../common/common.types";

export function getInventories(
  val: MySubscription | MySubscription[] | MySubscriptionLicense | MySubscriptionLicense[]
): MySubscriptionInventory[] {
  return (Array.isArray(val) ? val : [val])
    .map(e =>
      hasOwnProperty(e, "licenses") && Array.isArray(e.licenses)
        ? (e.licenses as MySubscriptionLicense[]).map(e => e.inventories).flat()
        : hasOwnProperty(e, "inventories") && Array.isArray(e.inventories)
        ? e.inventories
        : []
    )
    .flat();
}

export function isSubscribedFunctionality(
  licenses: MySubscription | MySubscription[] | MySubscriptionLicense | MySubscriptionLicense[],
  fnc: BundleItemFunctionalityType
): boolean {
  return getInventories(licenses)
    .flat()
    .map(e => e.functionality)
    .includes(fnc);
}

export function isAvailableFunctionality(
  licenses: MySubscription | MySubscription[] | MySubscriptionLicense | MySubscriptionLicense[],
  fnc: BundleItemFunctionalityType,
  quantity: number
): boolean {
  const inventories = getInventories(licenses).flat();

  if (inventories.find(e => e.functionality === fnc && e.quantity === INVENTORY_UNLIMITED_QUANTITY)) {
    return true;
  }

  const balance = inventories
    .filter(e => e.functionality === fnc && typeof e.quantity === "number")
    .reduce((p, e) => p + (e.quantity - (e.used || 0)), 0);

  return balance >= quantity;
}
